/**
 * Handlers for cleanup events in the notification service
 * @param {Object} service - The notification service instance
 * @returns {Object} Cleanup-related handler methods
 */
export const createCleanupHandlers = (service) => {
  /**
   * Handle logout event
   */
  const handleLogoutEvent = () => {
    // console.log('[NotificationService] Logout detected, stopping all operations');
    service.cleanup();
  };
  
  /**
   * Handle database cleanup request
   */
  const handleDatabaseCleanupRequest = () => {
    // console.log('[NotificationService] Database cleanup requested, releasing resources');
    service.stopPeriodicCheck();
    service.notificationsCache = null;
  };
  
  /**
   * Handle database force close request
   */
  const handleDatabaseForceClose = () => {
    // console.log('[NotificationService] Database force close requested, performing urgent cleanup');
    service.cleanup();
  };

  /**
   * Set up event handlers for database cleanup events
   */
  const setupCleanupEventHandlers = () => {
    // Listen for logout events
    window.addEventListener('user-logout-initiated', handleLogoutEvent);
    
    // Listen for database cleanup events
    window.addEventListener('database-cleanup-requested', handleDatabaseCleanupRequest);
    window.addEventListener('database-force-close', handleDatabaseForceClose);
  };

  /**
   * Remove database cleanup event handlers
   */
  const removeCleanupEventHandlers = () => {
    window.removeEventListener('user-logout-initiated', handleLogoutEvent);
    window.removeEventListener('database-cleanup-requested', handleDatabaseCleanupRequest);
    window.removeEventListener('database-force-close', handleDatabaseForceClose);
  };

  return {
    handleLogoutEvent,
    handleDatabaseCleanupRequest,
    handleDatabaseForceClose,
    setupCleanupEventHandlers,
    removeCleanupEventHandlers
  };
}; 